export default function IslandPicture() {
  return (
    <svg
      width='302'
      height='315'
      viewBox='0 0 302 315'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M155.83 0.53418C193.197 5.68906 205.458 54.9995 231.342 84.3242C255.828 112.066 297.561 127.228 301.179 165.207C304.928 204.569 275.12 237.039 248.501 264.471C222.534 291.23 191.861 315.372 155.83 314.996C120.06 314.622 91.5315 288.192 64.9505 262.551C36.2693 234.885 1.97111 206.522 0.548972 165.207C-0.899588 123.125 30.0543 90.0383 57.9924 60.4104C85.7399 30.9845 117.103 -4.80822 155.83 0.53418Z'
        fill='#F5F7F7'
      />
      <path
        d='M235.05 142.9C218.233 142.9 204.6 129.267 204.6 112.45C204.6 95.6329 218.233 82 235.05 82C251.867 82 265.5 95.6329 265.5 112.45C265.5 129.267 251.867 142.9 235.05 142.9Z'
        fill='#DFE6E5'
      />
      <path
        d='M126.06 122.953L94.7695 115.183C94.7695 115.183 114.72 97.5435 136.14 104.053L112.62 83.2635C112.62 83.2635 145.17 75.2835 159.66 99.4335C174.57 75.2835 207.12 83.2635 207.12 83.2635L183.18 104.683C205.02 96.7035 226.02 115.393 226.02 115.393L196.41 122.743C220.77 127.993 227.28 156.973 227.28 156.973L166.17 132.613L171.84 269.533H146.64L153.15 134.503L96.8695 156.973C96.8695 156.973 103.17 129.253 126.06 122.953Z'
        fill='#C0D4CB'
      />
      <path
        d='M215.1 313C215.1 283.987 174.702 260.5 124.8 260.5C74.8972 260.5 34.4998 283.987 34.4998 313'
        fill='#80BBAD'
      />
      <path
        d='M45.8969 223.203C36.5464 196.391 53.809 165.509 85.0662 154.942C116.323 144.376 150.234 157.037 159.45 183.85L45.8969 223.203Z'
        fill='#538184'
      />
      <path
        d='M129.3 277.301C129.82 277.301 130.21 277.167 130.73 277.032C132.679 276.227 133.719 273.945 132.939 271.797L100.838 185.352C100.058 183.338 97.8489 182.264 95.7695 183.07C93.82 183.875 92.7803 186.157 93.5601 188.305L125.661 274.75C126.181 276.361 127.741 277.301 129.3 277.301Z'
        fill='#778F9C'
      />
      <path
        d='M72.6742 214.3C63.6195 186.978 68.4131 160.471 83.4599 154.626C84.1256 154.354 84.7914 154.218 85.4572 153.946C100.77 150.004 119.945 167.811 129 194.59L72.6742 214.3Z'
        fill='#80BBAD'
      />
      <path
        d='M118.291 291.79C118.291 286.12 113.671 281.5 108.001 281.5C102.331 281.5 97.711 286.12 97.711 291.79'
        fill='#003F2D'
      />
      <path
        d='M118.291 291.79C118.291 286.12 113.671 281.5 108.001 281.5C102.331 281.5 97.711 286.12 97.711 291.79'
        fill='white'
        fillOpacity='0.08'
      />
      <path
        d='M102.75 291.79C102.75 286.12 98.1298 281.5 92.4598 281.5C86.7898 281.5 82.1698 286.12 82.1698 291.79'
        fill='#003F2D'
      />
      <path
        d='M102.75 291.79C102.75 286.12 98.1298 281.5 92.4598 281.5C86.7898 281.5 82.1698 286.12 82.1698 291.79'
        fill='white'
        fillOpacity='0.08'
      />
      <path
        d='M67.6799 283.39C67.6799 277.72 63.0599 273.1 57.3899 273.1C51.7199 273.1 47.0999 277.72 47.0999 283.39'
        fill='#003F2D'
      />
      <path
        d='M67.6799 283.39C67.6799 277.72 63.0599 273.1 57.3899 273.1C51.7199 273.1 47.0999 277.72 47.0999 283.39'
        fill='white'
        fillOpacity='0.08'
      />
      <path
        d='M193.68 279.19C193.68 273.52 189.06 268.9 183.39 268.9C177.72 268.9 173.1 273.52 173.1 279.19'
        fill='#003F2D'
      />
      <path
        d='M193.68 279.19C193.68 273.52 189.06 268.9 183.39 268.9C177.72 268.9 173.1 273.52 173.1 279.19'
        fill='white'
        fillOpacity='0.08'
      />
    </svg>
  );
}
